// Temporary tier filter. Tier is expressed with the query params that already exist
// (`subscribed=1` + `price_range[]`) so no backend change is needed - the bands mirror
// Item#subscription_tier_band (Essentials < $10, Premium $10-$50) closely enough for a
// discovery filter. Delete this module together with the Subscriptions section in
// Price/RemainingPriceFilters once the new filtering system ships.
export const TIER_ALL = 'all'
export const TIER_ESSENTIALS = 'essentials'
export const TIER_PREMIUM = 'premium'

export const TIER_PRICE_RANGES = {
  [TIER_ESSENTIALS]: 'range_2_10',
  [TIER_PREMIUM]: 'range_10_50',
}

const TIER_RANGE_VALUES = Object.values(TIER_PRICE_RANGES)

// Derived, not stored, and only when the query really is that tier: `subscribed` must be on
// and the tier range must be the only one selected. The other price controls write the same
// params independently - the Subscription pill can drop `subscribed` while the range stays,
// the quick selections and the slider append ranges that the backend ORs together (see
// ItemsSearch::Options#configure_new_price_filter) - so a looser read would leave the radio
// claiming a tier the results do not match.
//
// `null` means "no tier selected", which is not the same as `TIER_ALL`: picking All is what
// turns `subscribed` on for every tier, and a native radio that already renders checked does
// not fire onChange, so All must stay unchecked until the search really is an all-tier one.
export function getSelectedTier(selectedPriceRangeFilters = [], selectedPricingFilters = []) {
  if (!selectedPricingFilters.includes('subscribed')) {
    return null
  }

  const tierRanges = selectedPriceRangeFilters.filter((value) => TIER_RANGE_VALUES.includes(value))

  if (tierRanges.length === 0) {
    return TIER_ALL
  }

  if (tierRanges.length > 1 || selectedPriceRangeFilters.length > 1) {
    return null
  }

  const match = Object.entries(TIER_PRICE_RANGES).find(([, range]) => range === tierRanges[0])

  return match[0]
}

export function getPriceRangeForTier(tier, selectedPriceRangeFilters = []) {
  const withoutTierRanges = selectedPriceRangeFilters.filter((value) => !TIER_RANGE_VALUES.includes(value))

  return tier === TIER_ALL ? withoutTierRanges : [TIER_PRICE_RANGES[tier]]
}

// Selecting a tier auto-enables the Subscription pill and drops `free`, which is mutually
// exclusive with any price range.
export function getPricingForTier(selectedPricingFilters = []) {
  const entries = selectedPricingFilters.filter((value) => value !== 'free').map((value) => [value, '1'])

  return { ...Object.fromEntries(entries), subscribed: '1' }
}
